
import { Trip } from '@/Models/Trip';
import GoogleMap from '@/components/GoogleMap.vue'
import CalendarCard from '@/components/CalendarCard.vue';
import ContentCard from '@/components/ContentCard.vue'
import ImageUploadForm from '@/components/ImageUploadForm.vue';
import ImageCarousel from '@/components/ImageCarousel.vue';
import HeroSection from '@/components/HeroSection.vue';
import { Image } from '@/Models/Image';
import { $api } from '@/common/apiService';
import { defineComponent } from 'vue';
import SliderToggle from '@/components/SliderToggle.vue';


export default defineComponent ({
    name: "TripPage",
    components: {
        GoogleMap,
        CalendarCard,
        ContentCard,
        ImageUploadForm,
        ImageCarousel,
        HeroSection,
        SliderToggle
    },
    props: {
        id: {
            type: String,
            required: true
        }
    },
    data () {
        return {
            token: null as string | null,
            trip: null as Trip | null,
            heroImages: [] as string[],
            locationImageUri: "" as string,
            gallery: [] as Image[] | null,
            galleryFilterMyImages: false as boolean,
            loading: true as boolean,
            showUploadImage: false as boolean,
            showImageCarousel: false as boolean,
            selectedImage: -1 as number
        }
    },
    async mounted() {
        this.loading = true
        this.token = this.$store.getters.getSasToken
        this.trip = await $api.trips.get(Number.parseInt(this.id));

        if (this.trip?.coverImageId) {
            const coverImage = await $api.images.get(this.trip.coverImageId)
            if (coverImage) this.heroImages = [coverImage.uri + '?' + this.token];
        }
        if (this.trip?.locationImageId) {
            const locationImage = await $api.images.get(this.trip.locationImageId)
            if (locationImage) {
                if (this.heroImages.length === 0) {
                    this.heroImages = [locationImage.uri + '?' + this.token];
                } else {
                    this.locationImageUri = locationImage.uri + '?' + this.token;
                }
            }
        }
        await this.fetchGallery()
        this.loading = false
        if (this.$route.query.upload === 'true') {
            this.showUploadImage = true
            this.$router.replace({ query: {} })
        }
    },
    methods: {
        formatDateRange(startDate: string, endDate: string): string {
            const start = new Date(startDate);
            const end = new Date(endDate);
            const opts: Intl.DateTimeFormatOptions = { day: 'numeric', month: 'long' };
            const s = start.toLocaleDateString('da-DK', opts);
            const e = end.toLocaleDateString('da-DK', { ...opts, year: 'numeric' });
            return `${s} – ${e}`;
        },
        async fetchGallery() {
            const images = await $api.images.fetch(this.trip?.year, this.galleryFilterMyImages);
            if (images) {
                this.gallery = images.filter(image =>
                    image.id !== this.trip?.coverImageId &&
                    image.id !== this.trip?.locationImageId
                    )
            }
        },
        showGalleryCarousel(index: number) {
            if (this.gallery && this.gallery[index]) {
                this.selectedImage = index
                this.showImageCarousel = true
            }
        }
    },
    watch: {
        galleryFilterMyImages: function() {
            this.fetchGallery();
        }
    }

});
